import { useEffect, useState } from 'react';
import { fetchPublicApps, sortApps, type PublicApp } from '@/content/apps';
import { buildApps } from '@/seo/catalog';

/**
 * Catálogo de apps da home. Nasce com o do build (o mesmo que o robô leu) e
 * troca pelo da API assim que ela responde, então contagem, preço e descrição
 * nunca ficam para trás do produto.
 */
export function useCatalogApps(): PublicApp[] {
  const [apps, setApps] = useState<PublicApp[]>(buildApps);
  useEffect(() => {
    let off = false;
    fetchPublicApps()
      .then((data) => {
        if (!off && data.length > 0) setApps(sortApps(data));
      })
      .catch(() => {});
    return () => {
      off = true;
    };
  }, []);
  return apps;
}
